
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BookViewer from "@/views/UnterrichtKnowledge/BookViewer.vue";
import { BooksAllowedEnum } from "@/enums/BooksAllowedEnum";

const WikiDriveBuzzModule = namespace("wiki-drive-buzz");

@Component({
  components: { BookViewer },
})
export default class UnterrichtAdditionalKnowledgeForA extends Vue {
  public name = "UnterrichtAdditionalKnowledgeA";
  public bookId = BooksAllowedEnum.ADDITIONAL_KNOWLEDGE_CATEGORY_A;

  @WikiDriveBuzzModule.Action("findBook")
  public findBook: any;

  @WikiDriveBuzzModule.Getter("getAdditionalBookA")
  public bookData: any;

  @WikiDriveBuzzModule.Getter("getAdditionalBookAPage")
  public currentPage: any;

  public async mounted(): Promise<void> {
    await this.findBook(this.bookId);
  }
}
